// Remaining static/mock data for CBRNE dashboard sections without a real backend
// integration yet. Command Center, High-Level Dashboard, Team Leader, Staff/Patient
// apps and Connectivity were ported off this file's mock data but are now wired to
// real endpoints — see DashboardService, CommandCenterService, AnnouncementMemberService
// and PatientService. governanceControls is a static compliance checklist, not live
// telemetry, so it stays as authored content.
// Originally ported from SEHA_CBRNE_Smart_Command_Dashboard_Final_Functional.html's <script> data.

export const commandIncidents = [
  { id: 'ANN-402', kind: 'Announcement', title: 'Suspected Biological Exposure', type: 'Biological', location: 'Al Dhafra Hospital - ED / Decon Interface', landmark: 'Ambulance bay entrance', status: 'Active', risk: 'High', time: '42m', team: 'Team Brown', patients: 18 },
  { id: 'DRL-118', kind: 'Drill', title: 'Decontamination Drill', type: 'Exercise', location: 'Ambulance Bay / Decon Corridor', landmark: 'North receiving gate', status: 'Planned', risk: 'Moderate', time: 'Today 15:00', team: 'Team Alpha', patients: 6 },
  { id: 'ANN-388', kind: 'Announcement', title: 'Chemical Odor Concern', type: 'Chemical', location: 'Back Loading Area', landmark: 'Service corridor', status: 'Closed', risk: 'Low', time: 'Closed', team: 'Security + RSO', patients: 0 },
];

export const mockStakeholders = [
  { name: 'SEHA Executive Lead', role: 'Strategic oversight', channel: 'Conference + SMS', ack: 'Acknowledged', next: '15-min executive brief' },
  { name: 'DOH / Health Authority', role: 'Authority notification', channel: 'Secure email + phone', ack: 'Acknowledged', next: 'SITREP cycle' },
  { name: 'Civil Defense', role: 'Hazmat and perimeter support', channel: 'Radio + hotline', ack: 'Acknowledged', next: 'Confirm route support' },
  { name: 'National Ambulance', role: 'Transfer and staging', channel: 'CAD + phone', ack: 'Acknowledged', next: 'Confirm receiving units' },
  { name: 'Police / Security', role: 'Perimeter and access control', channel: 'Radio + secure chat', ack: 'Pending', next: 'Escalate acknowledgement' },
  { name: 'Lab / Public Health', role: 'Sample chain-of-custody', channel: 'Phone + email', ack: 'Pending', next: 'Confirm sample owner' },
];

export const inventoryItems = [
  { item: 'Level C PPE Kits', category: 'PPE', available: 42, inUse: 18, location: 'Central Store', status: 'OK' },
  { item: 'PAPR Batteries', category: 'Power', available: 11, inUse: 9, location: 'Decon Corridor', status: 'Low Stock' },
  { item: 'Decon Shower Lane', category: 'Decon', available: 1, inUse: 2, location: 'Warm Zone', status: 'High Load' },
  { item: 'Radiation Survey Meter', category: 'Detector', available: 3, inUse: 2, location: 'RSO Unit', status: 'OK' },
  { item: 'Chemical Detector', category: 'Detector', available: 2, inUse: 2, location: 'Team Brown', status: 'Watch' },
  { item: 'Ambulance Units', category: 'Transport', available: 4, inUse: 2, location: 'Staging Area', status: 'Ready' },
];

export const methaneTiles = [
  ['M', 'Major Incident', 'YES DECLARED'],
  ['E', 'Exact Location', 'Al Dhafra Hospital - ED / Decon Interface'],
  ['T', 'Type', 'Biological exposure, final confirmation pending'],
  ['H', 'Hazards', 'Aerosol / clothing contamination risk'],
  ['A', 'Access', 'Ambulance bay controlled entry'],
  ['N', 'Number of Casualties', '18 registered, expected up to 38'],
  ['E', 'Emergency Services', 'ED, RSO, Security, Civil Defense, Ambulance'],
  ['+', 'Nearest Landmark', 'Ambulance bay entrance'],
];

export const strategicActions = [
  { selected: true, title: 'Open standby decon lane', note: 'Reduces bottleneck and lowers operational risk.' },
  { selected: false, title: 'Escalate stakeholder acknowledgement', note: 'Police and Lab/Public Health pending.' },
  { selected: false, title: 'Activate overflow capacity', note: 'Prepare receiving ED/isolation and ambulance routes.' },
];

export const recommendations = [
  ['danger', 'Open standby decon lane', 'Lane 2 is operating at high load.'],
  ['warning', 'Escalate pending stakeholders', 'Police and Lab/Public Health acknowledgement pending.'],
  ['success', 'Maintain tablet sync monitoring', 'Patient documentation sync is 94%.'],
];

export const governanceControls = [
  ['success', 'Role-based access and privilege separation'],
  ['success', 'Audit logs for event, patient, team, resource and communication actions'],
  ['success', 'HTTPS / SSL / VPN / private subnet deployment readiness'],
  ['warning', 'Production MFA and backend RBAC enforcement required'],
];
